import "./styles.less";

import { useLocationTag } from "./LocationTag.hook";

export function LocationTag({ id, mode = "auto", hideAddress = false }) {
	const { address, neighborhood, estate, showAddress, loading, error } = useLocationTag({
		id,
		mode,
	});

	if (error || loading) return null;

	return (
		<span className="property-location-tag" >
			{!hideAddress && showAddress && address && <p style={{margin:'0'}}>{address}, </p>}
			<p>{neighborhood}, {estate} </p>
		</span>
	);
}


